import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { scrollToId } from "./Navbar";

const SALES_IMG =
  "https://images.unsplash.com/photo-1717258679609-08aaf5bbe3cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxib2VpbmclMjA3MzclMjBwbGFuZXxlbnwwfHx8fDE3ODY0MTIwMjN8MA&ixlib=rb-4.1.0&q=85&w=1600";

export const Sales = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);

  return (
    <section id="sales" ref={ref} data-testid="sales-section" className="py-28 md:py-36 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="relative overflow-hidden rounded-2xl border border-white/10 order-2 lg:order-1"
        >
          <motion.img
            style={{ y, scale: 1.15 }}
            src={SALES_IMG}
            alt="Aircraft nose close-up"
            className="w-full aspect-[4/3] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#020617]/60 to-transparent" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="order-1 lg:order-2"
        >
          <p className="font-mono-tech text-xs tracking-[0.25em] uppercase text-[#60A5FA] mb-6" data-testid="sales-overline">
            {t.sales.overline}
          </p>
          <h2 className="font-display font-bold tracking-tight leading-[1.05] text-4xl md:text-5xl" data-testid="sales-title">
            {t.sales.title}
          </h2>
          <p className="mt-6 text-slate-300 text-base md:text-lg leading-relaxed" data-testid="sales-body">
            {t.sales.body}
          </p>
          <button
            data-testid="sales-cta-btn"
            onClick={() => scrollToId("quote")}
            className="mt-9 inline-flex items-center gap-3 px-7 py-3.5 rounded-full bg-[#2563EB] hover:bg-[#1D4ED8] text-white font-medium transition-all duration-300 hover:scale-[1.04] group"
          >
            {t.sales.cta}
            <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};
